import clsx from 'clsx';
import Accordion from 'components/ui/ContentBlocks/Accordion';
import Markdown from 'components/Shared/Markdown';
import RichText from 'components/ui/ContentBlocks/RichText';
import { useTranslation } from 'hooks/useTranslation';
import { isString } from 'utils/string';
import styles from './FaqSection.module.scss';
import type { Document } from '@contentful/rich-text-types';

type Props = {
  items: {
    question: string;
    answer: string | Document;
  }[];
  noDesktopPadding?: boolean;
};

const FaqSection = ({ items, noDesktopPadding }: Props): JSX.Element | null => {
  const { t } = useTranslation(true);

  if (!items) {
    return null;
  }

  return (
    <div
      className={clsx(
        styles.container,
        noDesktopPadding && styles.noDesktopPadding,
      )}
    >
      <div className="py-5">
        <h3 className="pb-0">{t('questionsAndAnswers')}</h3>
        <Accordion>
          {items.map((item, i) => {
            if (isString(item.answer)) {
              return (
                <Accordion.Item key={i} title={item.question}>
                  <Markdown>{item.answer}</Markdown>
                </Accordion.Item>
              );
            }

            return (
              <Accordion.Item key={i} title={item.question}>
                <RichText fields={item.answer} />
              </Accordion.Item>
            );
          })}
        </Accordion>
      </div>
    </div>
  );
};

export default FaqSection;
